import api from "@/plugins/axios";
import Newsletter from "@/models/newsletter";
import { Meta } from "@/models/general";

const NewslettersAPI = {
  async new(payload: Newsletter): Promise<Newsletter | undefined> {
    return api.post(`/newsletters`, payload);
  },
  async update(payload: Newsletter): Promise<Newsletter | undefined> {
    return api.put(`/newsletters/${payload.id}`, payload);
  },
  async get(id: string): Promise<Newsletter> {
    return api.get(`/newsletters/${id}`);
  },
  async list(
    page = 1,
    pageSize = 10
  ): Promise<{ data: Newsletter[]; meta: Meta }> {
    return api.get(`/newsletters`, {
      params: { page: { number: page, size: pageSize } },
    });
  },
  async delete(id: string): Promise<void> {
    return api.delete(`/newsletters/${id}`);
  },
  async syncrhonize(id?: string): Promise<void> {
    return api.get(`/newsletters/${id}/syncrhonize`);
  },
  async syncrhonize_stats(
    id: string,
    start: string,
    end: string
  ): Promise<void> {
    return api.get(`/newsletters/${id}/syncrhonize_stats`, {
      params: {
        start: start,
        end: end,
      },
    });
  },
};

export default NewslettersAPI;
